import * as React from "react";
import Svg, { Path } from "react-native-svg";
const BulbIcon = (props) => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M12.0004 19.491C11.111 19.491 10.2217 19.4784 9.3323 19.491C9.06926 19.491 8.90642 19.4534 8.84379 19.1528C8.68095 18.4388 8.23001 17.9127 7.66633 17.4617C6.12562 16.2217 5.2488 14.6058 5.04838 12.6267C4.66007 9.16947 7.10266 5.83752 10.5223 5.16112C14.5056 4.37197 18.2133 6.83961 18.8897 10.848C19.3281 13.4659 18.4513 15.683 16.4346 17.4116C15.8333 17.9377 15.3073 18.5014 15.1068 19.2906C15.0442 19.5411 14.8814 19.5035 14.7185 19.5035C13.8041 19.491 12.9022 19.491 12.0004 19.491Z"
      fill="#EFD106"
    />
    <Path
      d="M12.0004 23.9878C11.6246 23.9878 11.2488 23.9878 10.873 23.9878C9.90851 23.9878 9.30726 23.4993 9.05674 22.5599C8.944 22.1089 9.00663 21.658 8.98158 21.207C8.96905 21.0066 9.09431 20.9816 9.24463 20.9816C11.0734 20.9816 12.8897 20.9816 14.7185 20.9816C14.9315 20.9816 14.9816 21.0692 14.9816 21.2571C14.9691 21.6329 14.9941 22.0087 14.9691 22.3845C14.9064 23.2613 14.1549 23.9628 13.253 23.9878C12.8521 24.0004 12.4263 23.9878 12.0004 23.9878Z"
      fill="#EFD106"
    />
    <Path
      d="M18.5641 17.8125C18.8021 17.825 18.9774 17.9252 19.1278 18.063C19.5536 18.4889 19.9921 18.9148 20.4179 19.3532C20.7812 19.7415 20.7937 20.1298 20.4555 20.468C20.1173 20.7937 19.729 20.7812 19.3407 20.4054C18.8898 19.967 18.4513 19.5285 18.0255 19.0776C17.7875 18.8271 17.7499 18.5265 17.9002 18.2133C18.0505 17.9377 18.301 17.85 18.5641 17.8125Z"
      fill="#FFE747"
    />
    <Path
      d="M6.1883 5.37406C6.1382 5.71227 6.02546 5.95026 5.74989 6.08805C5.46179 6.23836 5.18621 6.21331 4.96075 6.01289C4.44718 5.5369 3.94613 5.04838 3.47014 4.52229C3.20709 4.22166 3.20709 3.87093 3.49519 3.55778C3.78329 3.24463 4.15908 3.182 4.4597 3.44504C5.01085 3.92104 5.51189 4.45966 6.01294 4.98575C6.12567 5.08596 6.1382 5.26133 6.1883 5.37406Z"
      fill="#FFE747"
    />
    <Path
      d="M20.7061 4.05883C20.6685 4.25924 20.6059 4.45966 20.4556 4.60997C20.0046 5.06091 19.5662 5.52438 19.1028 5.96279C18.7646 6.28847 18.3762 6.26342 18.0631 5.96279C17.7499 5.64964 17.7124 5.26133 18.0255 4.92313C18.4765 4.44713 18.9399 3.98367 19.4159 3.53273C19.6414 3.31979 19.917 3.21958 20.2301 3.36989C20.5182 3.50768 20.681 3.73315 20.7061 4.05883Z"
      fill="#FFE747"
    />
    <Path
      d="M4.10901 20.706C3.74575 20.6935 3.53281 20.5306 3.38249 20.2676C3.20713 19.967 3.28229 19.6789 3.49523 19.4409C3.95869 18.9398 4.44721 18.4513 4.94826 17.9878C5.24888 17.7123 5.61214 17.7248 5.91277 18.0129C6.21339 18.2885 6.3136 18.6517 6.03803 18.9649C5.54951 19.516 5.02341 20.0171 4.49732 20.5181C4.38458 20.6434 4.20922 20.6684 4.10901 20.706Z"
      fill="#FFE747"
    />
    <Path
      d="M11.2487 1.74149C11.2487 1.41581 11.2362 1.09013 11.2487 0.764454C11.2613 0.313515 11.5619 0.0128887 11.9752 0.000362587C12.4011 -0.0121635 12.7268 0.300989 12.7393 0.764454C12.7519 1.40329 12.7519 2.04212 12.7393 2.68095C12.7268 3.10683 12.4137 3.43251 12.0128 3.44504C11.5995 3.45757 11.2613 3.11936 11.2487 2.66842C11.2362 2.36779 11.2487 2.05464 11.2487 1.74149Z"
      fill="#FFE747"
    />
    <Path
      d="M1.71644 12.7394C1.40329 12.7394 1.09013 12.7519 0.77698 12.7394C0.300989 12.7269 -0.0121636 12.4137 0.000362496 11.9753C0.000362496 11.5619 0.313515 11.2488 0.751928 11.2363C1.40329 11.2237 2.06717 11.2237 2.71853 11.2363C3.13189 11.2488 3.45756 11.5995 3.45756 11.9878C3.44504 12.3887 3.13189 12.7018 2.69347 12.7269C2.36779 12.7519 2.04212 12.7394 1.71644 12.7394Z"
      fill="#FFE747"
    />
    <Path
      d="M22.2717 11.2488C22.5974 11.2488 22.923 11.2363 23.2487 11.2488C23.6871 11.2738 23.9878 11.587 23.9878 12.0004C23.9878 12.4137 23.6871 12.7269 23.2487 12.7394C22.5974 12.7519 21.9335 12.7519 21.2821 12.7394C20.8562 12.7269 20.5305 12.3887 20.5431 11.9878C20.5431 11.587 20.8688 11.2613 21.2946 11.2488C21.6078 11.2363 21.946 11.2488 22.2717 11.2488Z"
      fill="#FFE747"
    />
    <Path
      d="M12.4513 7.50349C14.5682 7.56613 16.4221 9.43251 16.4847 11.5494C16.4972 12.1131 16.2467 12.4513 15.7958 12.4889C15.3073 12.5265 15.0192 12.2133 14.9816 11.6246C14.8939 10.1841 13.7916 9.09431 12.3636 9.00663C11.8 8.96905 11.4993 8.706 11.5119 8.24253C11.5244 7.75402 11.8751 7.47844 12.4513 7.50349Z"
      fill="white"
    />
  </Svg>
);
export default BulbIcon;
